module.exports = __webpack_public_path__ + "img/recursion.dff3e367.gif";